import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import { useSelector } from 'react-redux';
import { selectAuthDetails } from 'store/slices/authSlice';

const DashboardRedirect = () => {
	const auth_details = useSelector(selectAuthDetails);
	const isAdmin = auth_details?.role_id == 1;
	const dashboardPath = isAdmin ? AUTHENTICATED_ENTRY : '/dashboards/employee-dashboard';
	return <Navigate replace to={dashboardPath} />;
};

const ScreenLogin = React.lazy(() => import('views/screen/Login'));
const ScreenAllottedArea = React.lazy(() => import('views/screen/AllottedArea'));

const Routes = () => {

	return (
		<RouterRoutes>
			<Route path="/screen/login" element={<ScreenLogin />} />
			<Route path="/screen/allotted-area" element={<ScreenAllottedArea />} />
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<DashboardRedirect />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							key={route.key + index} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route 
							key={route.path} 
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key} 
									component={route.component}
									{...route.meta} 
								/>
							}
						/ >
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes
